export default {
  assistant: {
    error: "Ett tekniskt problem uppstod när ditt meddelande behandlades. Försök igen senare.",
    inputPlaceholder: "Skriv ditt meddelande...",
    title:"AI-assistent",
    welcome: "Hej! Jag är er digitala reseassistent. Jag är här för att göra er resa trevligare genom att hjälpa till med era reseplaner och resvägar. Tveka inte att skicka mig detaljerna om era resor – jag har ännu inte tillgång till dem. Hur kan jag hjälpa er idag? 😊"
  },
  common: {
    save: "Spara ändringar",
    cancel: "Avbryt",
    saving: "Sparar...",
    updating: "Uppdaterar...",
    back: "Tillbaka",
    error: "Fel",
    success: "Framgång",
    toast: {
      success: "Framgång",
      error: "Fel",
      info: "Information",
      warning: "Varning",
      copied: "Kopierat till urklipp",
      saved: "Ändringar sparade",
      deleted: "Borttaget framgångsrikt",
      updated: "Uppdaterat framgångsrikt"
    },
    cabinClass: "Kabinklass",
    bookingReference: "Bokningsreferens",
    confirmationNumbers: "Bekräftelsenummer",
    in: "i"
  },
  auth: {
    signOut: "Logga ut",
    signOutSuccess: "Utloggning lyckades",
    redirectingHome: "Omdirigerar till startsidan...",
    loginWithEmail: "Logga in med e-post",
    createAccount: "Skapa konto",
    forgotPassword: "Glömt lösenord",
    forgotPasswordInstructions: "Logga in med din e-post och ändra sedan ditt lösenord",
    firstName: "Förnamn",
    lastName: "Efternamn",
    emailAddress: "E-postadress",
    confirmEmailAddress: "Bekräfta e-postadress",
    termsAgreementPart1: "Genom att skapa ditt konto godkänner du våra",
    termsOfService: "Användarvillkor",
    privacyPolicy: "Integritetspolicy",
    signUpToManageTrips: "Registrera dig för att börja hantera dina resor",
    enterEmailForCode: "Ange din e-postadress för att få en engångskod",
    verifyEmail: "Verifiera e-post",
    noAccount: "Har du inget konto? Registrera dig",
    passwordValidation: "Lösenordet måste innehålla minst en versal bokstav, en gemen bokstav, en siffra, ett specialtecken och vara mellan 8 och 15 tecken långt.",
    loginDescription: "Följ flyg, organisera dina resor och få tillgång till all din reseinformation. Allt du behöver för en smidig resa, på ett och samma ställe.",
    loginAppDescription: "All din reseinformation på ett ställe"
  },
  settings: {
    title: "Inställningar",
    profile: {
      title: "Min profil",
      firstName: "Förnamn",
      lastName: "Efternamn",
      email: "E-postadress",
      country: "Land",
      city: "Stad",
      selectCountry: "Välj eller skriv ett land",
      enterCity: "Ange din stad"
    },
    language: {
      title: "Språk",
      preferred: "Föredraget språk"
    },
    currency: {
      title: "Valuta",
      preferred: "Föredragen valuta"
    },
    notifications: {
      title: "Aviseringar",
      emailNotifications: "E-postaviseringar",
      description: "Ta emot e-postaviseringar om viktiga uppdateringar"
    },
    consent: {
      title: "Samtyckshantering",
      open: "Öppna samtyckshanteraren",
      description: "Hantera dina integritets- och cookie-preferenser"
    },
    about: {
      title: "Om oss",
      tos: "Användarvillkor",
      privacy: "Integritetspolicy",
      faq: "Vanliga frågor"
    },
    contact: {
      title: "Kontakta oss",
      email: "feedback@checkmytrip.com"
    },
    social: {
      title: "Hitta oss på sociala medier"
    },
    profileUpdated: "Profil uppdaterad framgångsrikt",
    updateError: "Fel vid uppdatering av profil",
    passwordMismatch: "Lösenorden matchar inte",
    passwordTooShort: "Lösenordet måste vara minst 8 tecken långt",
    passwordUpdated: "Lösenord uppdaterat framgångsrikt",
    changePassword: "Ändra lösenord",
    newPassword: "Nytt lösenord",
    confirmPassword: "Bekräfta lösenord",
    updatePassword: "Uppdatera lösenord",
    deleteAccount: "Radera konto",
    deleteAccountDescription: "Radera permanent ditt konto och alla tillhörande data",
    confirmDelete: "Är du säker?",
    deleteWarning: "Denna åtgärd kan inte ångras. Detta kommer permanent att radera ditt konto och ta bort all din data från våra servrar.",
    confirmDeleteButton: "Ja, radera mitt konto",
    accountDeleted: "Ditt konto har raderats framgångsrikt.",
    deleteError: "Misslyckades med att radera konto",
    feedback: {
      title: "Återkoppling",
      description: "Vi värdesätter din återkoppling. Hjälp oss att förbättra vår tjänst genom att dela dina tankar.",
      button: "Ge återkoppling"
    }
  },
  newTrip: {
    title: "Lägg till en ny resa",
    bookingReference: "Bokningsreferens",
    bookingReferenceDesc: "Ange din 6 tecken långa bokningsreferens och se till att för- och efternamnet i din profil är desamma som i din bokning.",
    bookingRefPlaceholder: "Referens (t.ex. ABC123)",
    bookingRefTooShort: "Bokningsreferens måste vara minst 6 tecken lång",
    bookingRefTooLong: "Bokningsreferens får vara högst 10 tecken lång",
    lastNamePlaceholder: "Efternamn",
    findBooking: "Hitta bokning",
    gmailSync: "Synkronisera med Gmail",
    gmailSyncDesc: "Låt oss skanna din Gmail-inkorg efter resebokningar",
    connectGmail: "Anslut Gmail-konto",
    emailForward: "Vidarebefordra bokningsmail",
    emailForwardDesc: "Vidarebefordra din bokningsbekräftelse för att lägga till din resa",
    emailCopied: "E-postadress kopierad",
    emailCopiedDesc: "E-postadressen har kopierats till urklipp",
    copyEmail: "Kopiera e-postadress",
    manual: "Manuell inmatning",
    manualDesc: "Lägg till detaljer om din resa manuellt",
    startManual: "Starta manuell inmatning",
    bookingSubmitted: "Bokning skickad",
    processingBooking: "Vi letar efter din bokning...",
    gmailConsent: "Gmail-anslutning",
    gmailProcessing: "Ansluter till ditt Gmail-konto...",
    manualEntry: "Manuell resinmatning",
    manualEntryDesc: "Skapa en resa genom att själv lägga till flyg- och hotelldetaljer",
    profileMismatch: "Tyvärr matchar inte din profilinformation bokningen. Gå till Profil och se till att ditt för- och efternamn är desamma som de som användes för att göra bokningen. Du kan också försöka importera din resa med följande alternativ nedan genom att vidarebefordra din bokningsbekräftelsemail eller ange resan manuellt.",
    drawer: {
      addTripDetails: "Lägg till resedetaljer",
      tripInfo: "Reseinformation",
      tripName: "Resans namn",
      tripType: "Restyp",
      selectTripType: "Välj restyp",
      leisure: "Fritid",
      business: "Affärer",
      family: "Familj",
      bleisure: "Affärer och fritid",
      travelers: "Antal resenärer",
      addFlight: "Lägg till flyg",
      flightNumber: "Flygnummer (t.ex. SK1234)",
      departureDate: "Avgångsdatum",
      addedFlights: "Tillagda flyg",
      from: "Från:",
      to: "Till:",
      terminal: "Terminal:",
      departure: "Avgång:",
      arrival: "Ankomst:",
      addHotel: "Lägg till hotell",
      hotelName: "Hotellnamn",
      cityName: "Stadsnamn",
      selectCheckInOut: "Välj in- och utcheckningsdatum",
      checkIn: "Incheckning",
      checkOut: "Utcheckning",
      addedHotels: "Tillagda hotell",
      createTrip: "Skapa resa",
      adding: "Lägger till...",
      selectFlight: "Välj flyg",
      confirmFlight: "Bekräfta flyg",
      step1: "Info",
      step2: "Flyg",
      step3: "Hotell",
      step4: "Granskning",
      next: "Nästa",
      back: "Tillbaka",
      review: "Granska",
      flightsStepEmpty: "Lägg till minst ett flyg till din resa",
      flightsStepWithFlights: "Du har lagt till {{count}} flyg",
      hotelsStepEmpty: "Lägg till hotell till din resa (valfritt)",
      hotelsStepWithHotels: "Du har lagt till {{count}} hotell",
      reviewTrip: "Granska din resa",
      reviewDescription: "Kontrollera din resedetaljer innan du skapar den",
      tripSummary: "Resesammanfattning",
      flightsSummary: "Flyg",
      hotelsSummary: "Hotell"
    }
  },
  discover: {
    title: "Upptäck upplevelser",
    subtitle: "Hitta och utforska aktiviteter för ditt nästa äventyr",
    getInspired: "Bli inspirerad",
    searchFilters: "Sökfilter",
    search: "Sök",
    city: "Stad",
    enterCityName: "Ange stadens namn",
    priceRange: "Prisintervall",
    min: "Min",
    max: "Max",
    radius: "Radie (km)",
    enterRadius: "Ange radie",
    searchButton: "Sök",
    categoryTypes: "Kategorier",
    popularActivities: "Populära aktiviteter",
    searchPlaceholder: "Sök aktiviteter, platser eller upplevelser...",
    allActivities: "Alla aktiviteter",
    inspiration: {
      location: "Plats",
      price: "Prisintervall",
      bestTimeToVisit: "Bästa tiden att besöka",
      howToGetThere: "Hur man tar sig dit"
    },
    categories: {
      tour: "Tur",
      adventure: "Äventyr",
      food: "Mat och dryck",
      culture: "Kultur",
      sightseeing: "Sightseeing",
      entertainment: "Underhållning",
      nature: "Natur",
      wellness: "Wellness",
      sport: "Sport",
      workshop: "Workshop"
    }
  },
  index: {
    greeting: "Hej, Resenär",
    greetingWithName: "Hej, {{name}}",
    manageTrips: "Hantera dina resor",
    bookingRef: "Bokningsreferens",
    lastName: "Efternamn",
    addTrip: "Lägg till resa",
    timeline: "Din tidslinje",
    travelPlans: "Dina resplaner",
    errorFetchingTrips: "Se till att du är ansluten till ett konto med motsvarande namn och e-post.",
    viewUpcomingFlights: "Visa kommande flyg",
    welcome: {
      title: "Välkommen till din reseupplevelse!",
      features: {
        tripManagement: {
          title: "Resehantering",
          description: "Håll alla dina resedetaljer på ett ställe - flyg, hotell och aktiviteter."
        },
        tripAlerts: {
          title: "Reseaviseringar",
          description: "Få snabba aviseringar om dina flyg, gateändringar och viktiga reseuppdateringar."
        },
        offers: {
          title: "Personliga erbjudanden",
          description: "Få skräddarsydda reseerbjudanden baserat på dina preferenser och tidigare resor."
        },
        inspiration: {
          title: "Reseinspiratör",
          description: "Upptäck nya destinationer och få personliga rekommendationer för dina äventyr"
        }
      },
      tips: {
        profile: "Komplettera din profil för att få personliga rekommendationer",
        addTrip: "Klicka på + knappen för att lägga till din första resa",
        notifications: "Aktivera aviseringar för att aldrig missa viktiga reseuppdateringar",
        dates: "Håll koll på viktiga resedatum i din kalender"
      },
      getStarted: "Snabba tips för att komma igång",
      ready: "Redo att börja din resa? Låt oss göra varje resa minnesvärd! ✈️"
    },
    importAdtdTripSuccess: "Resan har importerats",
    importAdtdTripError: "Det gick inte att importera resan till detta konto",
    checkYourTrips: "Kontrollera dina resor i appen"
  },
  tripCard: {
    daysLeft: "dagar",
    flightDetails: "Flygdetaljer",
    terminal: "Terminal",
    gate: "Gate",
    checkIn: "Check-in",
    flightInfo: "Flyginformation",
    airline: "Flygbolag",
    flight: "Flyg",
    departure: "Avgång",
    arrival: "Ankomst",
    getFlightDetails: "Få flygdetaljer",
    destinationInfo: "Destinationsinfo",
    weather: "Väder",
    activities: "Rekommenderade aktiviteter",
    food: "Restauranger & caféer",
    today: "Idag",
    dayAgo: "1 dag sedan",
    daysAgo: "{{count}} dagar sedan",
    remainingDay: "1 dag kvar",
    remainingDays: "{{count}} dagar kvar",
    checkStatus: "Kontrollera status",
    tripStatus: {
      ongoing: "Pågående resa",
      upcoming: "Kommande resa",
      past: "Tidigare resa"
    },
    booking: "Bokning",
    taxiTransfer: "Taxitransfer",
    taxiTransferDesc: "Boka en taxitransfer till ditt hotell eller flygplats",
    taxiTransferComingSoon: "Taxitransfer kommer snart",
    tripDetails: "Resedetaljer",
    deleteTrip: "Radera resa",
    confirmDelete: "Radera resa?",
    deleteWarning: "Denna åtgärd kan inte ångras. Detta kommer permanent att radera din resa till {{tripName}} och ta bort den från ditt konto.",
    confirmDeleteButton: "Ja, radera resa",
    tripDeleted: "Resan har raderats framgångsrikt.",
    deleteError: "Fel vid radering av resa",
    carRental: "Biluthyrning",
    carModel: "Bilmodell",
    pickupLocation: "Upphämtningsplats",
    dropoffLocation: "Återlämningsplats",
    pickup: "Upphämtning",
    dropoff: "Återlämning",
    confirmationNumber: "Bekräftelsenummer",
    addToCalendar: "Lägg till i kalender",
    notifications: "Aviseringar",
    notificationsDescription: "Viktiga aviseringar om dina resor",
    noNotifications: "Inga aviseringar än",
    notificationsOnMobile: "Denna funktion är endast tillgänglig i mobilappen för tillfället",
    loadingNotifications: "Laddar notifikationer...",
    economy: "Ekonomi"
  },
  weather: {
    in: "Väder i",
    loading: "Laddar väderdata...",
    currentWeather: "Aktuellt väder",
    forecast: "Prognos",
    temperature: "Temperatur",
    feelsLike: "Känns som",
    wind: "Vind",
    humidity: "Luftfuktighet",
    precipitation: "Nederbörd",
    pressure: "Tryck",
    visibility: "Sikt",
    uvIndex: "UV Index",
    sunrise: "Soluppgång",
    sunset: "Solnedgång",
    daily: "Dagligen",
    hourly: "Varje timme",
    today: "Idag",
    tomorrow: "Imorgon",
    min: "Min",
    max: "Max"
  },
  sidebar: {
    assistant: "Assistent",
    myTrips: "Mina resor",
    discover: "Upptäck",
    newTrip: "Ny resa",
    profile: "Profil",
    feedback: "Återkoppling"
  },
  errors: {
    configurationError: "Konfigurationsfel",
    websiteNotConfigured: "Webbplatsen är inte korrekt konfigurerad."
  }
}
